import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import BackIcon from '@fuww/library/src/Icons/BackIcon';
import { useApolloClient } from '@apollo/client';
import { ParsedUrlQuery } from 'node:querystring';
import messages from '../../../lib/messages.json';
import LinkAndAnchor from '../../LinkAndAnchor';
import { useSiteContext } from '../../SiteContext';
import getJobEventTracker from '../../../lib/getJobEventTracker';
import { getRouterState } from '../../../lib/savedRouterState';
import { Job } from '../../../lib/graphql/api/graphql';

const BackButton = ({
  job,
  showIcon = true,
}: {
  job?: Pick<Job, '_id' | 'city' | 'company' | 'id' | 'title' > | null;
  showIcon?: boolean;
}) => {
  const intl = useIntl();
  const { locale, isCareerPage } = useSiteContext();
  const { query: { companySlug } } = useRouter();
  const [
    lastJobsQuery,
    setLastJobsQuery,
  ] = useState<ParsedUrlQuery | null>(null);
  const apolloClient = useApolloClient();

  useEffect(() => {
    setLastJobsQuery({
      ...getRouterState(
        isCareerPage ? 'careers' : 'jobs',
      )?.query,
    });
  }, [isCareerPage]);

  return lastJobsQuery ? (
    <LinkAndAnchor
      route={isCareerPage ? `careers.${locale}` : `jobs.${locale}`}
      params={{
        ...lastJobsQuery,
        ...isCareerPage ? { companySlug } : {},
      }}
      onClick={() => {
        getJobEventTracker(
          apolloClient,
          'Meteor Job back button',
          job,
        )();
      }}
      scroll={!lastJobsQuery}
      useRouter
    >
      {showIcon && <BackIcon />}
      {intl.formatMessage(messages['jobs.returnToList'])}
    </LinkAndAnchor>
  ) : null;
};

BackButton.propTypes = {
  job: PropTypes.shape({}),
};

export default BackButton;
